import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { FaRegClock, FaPencilAlt } from "react-icons/fa";
import { MdRemoveCircleOutline } from "react-icons/md";
import { ToastContainer, toast } from "../../../toast";
import ConformationModal from "../Components/ConformationModal"; // ✅ adjust import path

// GraphQL mutation
const REMOVE_MODULE_FROM_CLUSTER = gql`
  mutation RemoveModuleFromCluster(
    $campusName: String!
    $clusterId: String!
    $moduleId: String!
  ) {
    removeModuleFromCluster(
      campusName: $campusName
      clusterId: $clusterId
      moduleId: $moduleId
    ) {
      id
      campusName
      name
      modules {
        moduleID
        enabled_dates
      }
    }
  }
`;

const ModuleCard = ({
  moduleId,
  clusterId,
  campusName,
  name,
  short_description,
  domain,
  start_date,
  end_date,
  daywise_plan = [],
  onEdit,
}) => {
  const [removeModule, { loading }] = useMutation(REMOVE_MODULE_FROM_CLUSTER, {
    refetchQueries: ["GetCluster"], // refresh cluster after delete
  });

 
  

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const days = daywise_plan?.length || 0;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleDeleteModule = async () => {
    try {
      await removeModule({
        variables: { campusName, clusterId, moduleId },
      });
      toast.success(`Module "${name}" removed successfully`, {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      console.error("❌ Error removing module:", err);
      toast.error("Failed to remove module ❌", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setShowDeleteModal(false);
    }
  };

  return (
    <>
      <div
        className="relative shadow-lg rounded-2xl w-[300px] min-h-[320px] bg-white flex flex-col justify-between 
                  transition-all duration-300"
      >
        {/* Top Right Edit/Delete Icons */}
        <div className="absolute flex gap-3 top-4 right-4">
          <FaPencilAlt
            onClick={onEdit}
            className="w-5 h-5 text-gray-400 transition-colors cursor-pointer hover:text-blue-600"
            title="Edit Module"
          />
          <MdRemoveCircleOutline
            onClick={() => setShowDeleteModal(true)}
            className={`h-6 w-6 ${
              loading ? "text-gray-300 cursor-wait" : "text-gray-500"
            } hover:text-red-500 transition-colors cursor-pointer`}
            title={loading ? "Removing..." : "Remove Module"}
          />
        </div>

        {/* Module Info */}
        <div className="p-6">
          <div className="mb-2 text-xl font-bold text-gray-800">{name}</div>
          <div className="mb-3 text-sm text-slate-600 line-clamp-3">
            {short_description}
          </div>

          <div className="mb-1 text-xs text-gray-500">
            <span className="font-medium">Domain:</span> {domain || "N/A"}
          </div>
          <div className="text-xs text-gray-500">
            <span className="font-medium">Start:</span> {formatDate(start_date)}
            {"  |  "}
            <span className="font-medium">End:</span> {formatDate(end_date)}
          </div>
        </div>

        {/* Footer with days info */}
        <div className="flex items-center justify-between px-6 py-4 border-t bg-gray-50 rounded-b-2xl">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <FaRegClock /> {days} Day{days !== 1 ? "s" : ""}
          </div>
        </div>
      </div>

      {/* ✅ Delete Confirmation Modal */}
      {showDeleteModal && (
        <ConformationModal
          openModal={showDeleteModal}
          setOpenModal={setShowDeleteModal}
          event={handleDeleteModule}
          text="Are you sure you want to delete this module?"
        />
      )}
    </>
  );
};

export default ModuleCard;
